// extracted by mini-css-extract-plugin
export default {"header":"styles_header__JDH3i","logo_container":"styles_logo_container__PQoAm"};